import { Button, ButtonGroup } from "@material-ui/core";

const CountryToggleButtons = ({
    onChange,
    selectedCountry = "USA",
    setSelectedCountry = () => {},
}) => {
    const handleCountryClick = (e, country) => {
        e.preventDefault();
        setSelectedCountry(country);
        onChange?.(country);
    };

    return (
        <ButtonGroup variant="outlined" size="small">
            <Button
                variant={selectedCountry === "USA" ? "contained" : "outlined"}
                onClick={(e) => handleCountryClick(e, "USA")}
                color="primary"
            >
                🇺🇸 USA
            </Button>
            <Button
                variant={selectedCountry === "CAN" ? "contained" : "outlined"}
                onClick={(e) => handleCountryClick(e, "CAN")}
                color="primary"
            >
                🇨🇦 CAN
            </Button>
        </ButtonGroup>
    );
};

export default CountryToggleButtons;
